import {
    ref, Ref, computed
} from 'vue';
import { GridApi } from '@ag-grid-community/core';
import { exportGridToCSV } from '../utils/csvExportUtils';

/**
 * Composable for CSV export functionality
 * Provides clean interface for exporting AG Grid data to CSV
 *
 * @param gridApi - Reactive reference to AG Grid API
 * @param totalRecords - Reactive reference or computed for total records count
 * @param options - Optional configuration
 */
export const useCSVExport = (
    gridApi: Ref<GridApi | null>,
    totalRecords: Ref<number> | (() => number),
    options?: {
        filePrefix?: string;
        successMessage?: string;
        errorMessage?: string;
    },
    facets?: Record<string, Record<string, unknown>>
) => {
    const isExporting = ref(false);
    
    // Handle both Ref and computed values for totalRecords
    const recordCount = computed(() => {
        return typeof totalRecords === 'function' ? totalRecords() : totalRecords.value;
    });

    const exportToCSV = () => {
        exportGridToCSV(gridApi, recordCount.value, isExporting, {
            ...options,
            facets
        });
    };

    return {
        isExporting,
        exportToCSV
    };
};
